









































import { Component, Vue, Prop } from 'vue-property-decorator'
import Axios from 'axios'
import { Playlist } from '@/classes/playlist'
import { USAGE_STAT_FEATURES } from '../../../../../system/usage-stats'

enum PREFIX_METHODS {
  Number = 'number',
  Text = 'text'
}

@Component({
  components: {
    BaseAction: require('./_Base').default
  }
})
export default class Create extends Vue {
  @Prop()
  selectedPlaylists: Playlist[]

  method: PREFIX_METHODS = PREFIX_METHODS.Number
  prefixText: string = ''

  prefixNumberStart: number = 0
  prefixNumberLeadingZero: boolean = true
  prefixNumberReplaceExisting: boolean = true

  get validation(): { message?: string, valid: boolean } {
    if (this.selectedPlaylists.length === 0) return { message: 'Please select the playlists you want to prefix', valid: false }

    return { valid: true }
  }

  async save() {
    if (!this.validation.valid) return

    window.addUsageStat(USAGE_STAT_FEATURES.ManagePlaylist, 'prefix', 'confirm', {
      method: this.method
    })

    return Axios.post('/playlist/prefix', {
      ids: this.selectedPlaylists.map(x => x._id),
      method: this.method,
      text: this.prefixText,
      numberStart: this.prefixNumberStart,
      leadingZero: this.prefixNumberLeadingZero,
      replaceExisting: this.prefixNumberReplaceExisting
    }).then((res) => {
      this.$buefy.notification.open('Prefixed playlists')

      return res
    })
  }
}
